/*
  Elarose — i sotto-menu del drawer sono accordion inline, non pannelli a scorrimento.

  MenuDrawer (assets/global.js) aggancia un listener di click su OGNI <summary> del drawer.
  Quel listener e' pensato per il pannello laterale: nasconde il menu principale (classe
  .submenu-open -> visibility: hidden) e intrappola il focus dentro il sotto-menu. Per un
  accordion serve solo il toggle nativo di <details>.

  Questo listener gira in fase di CAPTURE su document, quindi prima di qualsiasi listener
  registrato sul <summary> stesso, a prescindere dall'ordine di caricamento degli script.
  stopPropagation() impedisce all'evento di raggiungere il target -- e quindi al codice di
  MenuDrawer di partire -- senza toccare l'activation behavior del <details>, che continua
  ad aprirsi e chiudersi da solo (solo preventDefault lo bloccherebbe).

  Il <summary> del drawer principale non ha data-accordion, quindi resta gestito da Dawn.
*/
document.addEventListener(
  'click',
  (event) => {
    const summary = event.target.closest?.('summary');
    if (!summary) return;

    const details = summary.parentElement;
    if (details && details.hasAttribute('data-accordion')) {
      event.stopPropagation();
    }
  },
  true
);
